


// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { Link } from 'react-router-dom'
// import ReactPaginate from 'react-paginate'
// import Loader from 'react-js-loader'
// // import loader from "../challengeManagement/loder.gif"
// import { apiRequest } from '../apiServices/allApi'


// const $ = require('jquery')
// $.Datatable = require('datatables.net')

// export default function Conflictgame () {
//   const [challenge, setchallenge] = useState()
//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
//   const nodeMode = process.env.NODE_ENV
//   if (nodeMode === 'development') {
//     var baseUrl = beckendLocalApiUrl
//   } else {
//     baseUrl = beckendLiveApiUrl
//   }

//   // Pagination states
//   let limit = 10
//   const [pageNumber, setPageNumber] = useState(0)
//   const [numberOfPages, setNumberOfPages] = useState(0)

//   const handlePageClick = async data => {
//     let currentPage = data.selected + 1
//     setPageNumber(currentPage)
//   }

//   const Allchallenge = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//     try {
//       const res = await apiRequest(`admin/challange_get/dashboard/all?page=${pageNumber}&_limit=${limit}`, "GET", null, headers);
//       setchallenge(res.data?.status)
//       setNumberOfPages(res?.totalPages)
//     } catch (error) {
//       console.log(error)
//     }
//   }

//   const dateFormat = e => {
//     const date = new Date(e)
//     const newDate = date.toLocaleString('default', {
//       month: 'long',
//       day: 'numeric',
//       hour: 'numeric',
//       hour12: true,
//       minute: 'numeric'
//     })
//     return newDate
//   }

//   const CancelGame = async id => {
//     const confirm = window.confirm('are you sure to cancel')

//     if (confirm) {
//       let access_token = localStorage.getItem('token')
//       access_token = localStorage.getItem('token')
//       const headers = {
//         Authorization: `Bearer ${access_token}`
//       }
//       try {
//         const res = await apiRequest(`challange/Cancel/admin/${id}`,
//           { Cancelled_by: access_token }, "PATCH", headers);
//         Allchallenge()
//       } catch (error) {
//         window.alert('sorry try again')
//       }
//     }
//   }

//   useEffect(() => {
//     Allchallenge()
//   }, [pageNumber, limit])

//   if (challenge === undefined) {
//     return null
//   }

//   return (
//     <div className='conflictgame-container'>
//       <div className='conflictgame-main-card'>
//         <h2 className='conflictgame-heading'>Active Games List</h2>

//         {/* Responsive Table Wrapper */}
//         <div className='table-responsive-wrapper'>
//           <table className='conflictgame-modern-table'>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>ID</th>
//                 <th>Player 1</th>
//                 <th>Player 2</th>
//                 <th>Amount</th>
//                 <th>Status</th>
//                 <th>Game Type</th>
//                 <th>Date</th>
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {challenge &&
//                 challenge?.map((game, key) => (
//                   <tr key={game._id || key}>
//                     <td>{key + 1}</td>
//                     <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{game._id}</td>

//                     <td>
//                       <span className='player-name-text'>
//                         {game.Created_by?.Name ?? 'N/A'}
//                       </span>
//                     </td>

//                     <td>
//                       <span className='player-name-text'>
//                         {game.Accepetd_By ? game.Accepetd_By?.Name : 'N/A'}
//                       </span>
//                     </td>

//                     <td>
//                       <span className='game-amount-text'>₹{game.Game_Ammount}</span>
//                     </td>

//                     <td className='status-badge-text'>
//                       {game.Status}
//                     </td>

//                     <td style={{ color: '#cbd5e1' }}>{game.Game_type}</td>

//                     <td>{dateFormat(game.createdAt).split(',')[0]}</td>

//                     <td>
//                       <Link
//                         className='btn-conflictgame-view'
//                         to={`/view/${game._id}`}
//                       >
//                         View
//                       </Link>
//                     </td>
//                   </tr>
//                 ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination Container */}
//         <div className='pagination-container'>
//           <ReactPaginate
//             previousLabel={'Previous'}
//             nextLabel={'Next'}
//             breakLabel={'...'}
//             pageCount={numberOfPages}
//             marginPagesDisplayed={2}
//             pageRangeDisplayed={3}
//             onPageChange={handlePageClick}
//             containerClassName={'pagination justify-content-center'}
//             pageClassName={'page-item'}
//             pageLinkClassName={'page-link'}
//             previousClassName={'page-item'}
//             previousLinkClassName={'page-link'}
//             nextClassName={'page-item'}
//             nextLinkClassName={'page-link'}
//             breakClassName={'page-item'}
//             breakLinkClassName={'page-link'}
//             activeClassName={'active'}
//           />
//         </div>

//       </div>
//     </div>
//   )
// }


import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import Loader from 'react-js-loader'
// import loader from "../challengeManagement/loder.gif"
import { apiRequest } from '../apiServices/allApi'

const $ = require('jquery')
$.Datatable = require('datatables.net')

export default function Conflictgame () {
  const [challenge, setchallenge] = useState([])
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }

  // Pagination states (API uses 1-based index)
  let limit = 10
  const [pageNumber, setPageNumber] = useState(1)
  const [numberOfPages, setNumberOfPages] = useState(0)

  // ReactPaginate returns 0-based index (`selected`), so we add + 1
  const handlePageClick = (data) => {
    let selectedPage = data.selected + 1
    setPageNumber(selectedPage)
  }

  const Allchallenge = async (page) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      // Pass the current page directly to prevent stale state issues
      const res = await apiRequest(`admin/challange_get/dashboard/all?page=${page}&_limit=${limit}`, "GET", null, headers);
      
      // Ensure backend data mapping matches correctly
      setchallenge(res.data?.status || res.data || [])
      setNumberOfPages(res?.totalPages || res.data?.totalPages || 0)
    } catch (error) {
      console.log("Error fetching challenge list:", error)
    }
  }

  const dateFormat = e => {
    if (!e) return 'N/A'
    const date = new Date(e)
    const newDate = date.toLocaleString('default', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric'
    })
    return newDate
  }

  const CancelGame = async id => {
    const confirm = window.confirm('are you sure to cancel')

    if (confirm) {
      let access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }
      try {
        const res = await apiRequest(`challange/Cancel/admin/${id}`,
          { Cancelled_by: access_token }, "PATCH", headers);
        Allchallenge(pageNumber)
      } catch (error) {
        window.alert('sorry try again')
      }
    }
  }

  useEffect(() => {
    Allchallenge(pageNumber)
  }, [pageNumber])

  // Helper function to return inline styles for the Status badge
  const getStatusBadgeStyle = (status) => {
    const baseStyle = {
      display: 'inline-block',
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }

    switch (status?.toLowerCase()) {
      case 'new':
        return {
          ...baseStyle,
          backgroundColor: '#2563eb',
          color: '#ffffff'
        }
      case 'running':
        return {
          ...baseStyle,
          backgroundColor: '#16a34a',
          color: '#ffffff'
        }
      case 'conflict':
        return {
          ...baseStyle,
          backgroundColor: '#dc2626',
          color: '#ffffff'
        }
      case 'pending':
        return {
          ...baseStyle,
          backgroundColor: '#ca8a04',
          color: '#ffffff'
        }
      default:
        return {
          ...baseStyle,
          backgroundColor: '#6b7280',
          color: '#ffffff'
        }
    }
  }

  return (
    <div className='conflictgame-container'>
      <div className='conflictgame-main-card'>
        <h2 className='conflictgame-heading'>Active Games List</h2>

        {/* Responsive Table Wrapper */}
        <div className='table-responsive-wrapper'>
          <table className='conflictgame-modern-table'>
            <thead>
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Player 1</th>
                <th>Player 2</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Game Type</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {challenge && challenge.length > 0 ? (
                challenge.map((game, key) => (
                  <tr key={game._id || key}>
                    <td>{(pageNumber - 1) * limit + key + 1}</td>
                    <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{game._id}</td>

                    <td>
                      <span className='player-name-text'>
                        {game.Created_by?.Name ?? 'N/A'}
                      </span>
                    </td>

                    <td>
                      <span className='player-name-text'>
                        {game.Accepetd_By ? game.Accepetd_By?.Name : 'N/A'}
                      </span>
                    </td>

                    <td>
                      <span className='game-amount-text'>₹{game.Game_Ammount}</span>
                    </td>

                    <td>
                      <span style={getStatusBadgeStyle(game.Status)}>
                        {game.Status}
                      </span>
                    </td>

                    <td style={{ color: '#cbd5e1' }}>{game.Game_type}</td>

                    <td>{dateFormat(game.createdAt).split(',')[0]}</td>

                    <td>
                      <Link
                        className='btn-conflictgame-view'
                        to={`/view/${game._id}`}
                      >
                        View
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textCenter: 'center', padding: '20px' }}>
                    No Games Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Container */}
        {numberOfPages > 1 && (
          <div className='pagination-container' style={{ marginTop: '20px' }}>
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageCount={numberOfPages}
              forcePage={pageNumber - 1} // Force active page to sync with 0-based index
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={'pagination justify-content-center'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </div>
        )}

      </div>
    </div>
  )
}